import { render } from "./bulkImport1.vue?vue&type=template&id=017de331&scoped=true"
import script from "./bulkImport1.vue?vue&type=script&lang=js"
export * from "./bulkImport1.vue?vue&type=script&lang=js"

import "./bulkImport1.vue?vue&type=style&index=0&id=017de331&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017de331"]])

export default __exports__